class InvoicesForm
  constructor: ->
    $(document).ready =>
      Inputmask().mask('#invoice_issuing_time_time')
      Inputmask().mask('#invoice_issuing_time_date')
    $('#invoice_net_value_in_cents').change(this.update_gross_value_in_cents)
    $('#invoice_vat_rate').change(this.update_gross_value_in_cents)
    $('#invoice_issuing_time_time').change(this.update_issuing_time)
    $('#invoice_issuing_time_date').change(this.update_issuing_time)

  update_gross_value_in_cents: ->
    net_value_in_cents = parseInt($('#invoice_net_value_in_cents').val())
    vat_rate = parseInt($('#invoice_vat_rate').val())
    vat = Math.round(net_value_in_cents * vat_rate / 100)
    $('#invoice_gross_value_in_cents').val(net_value_in_cents + vat)

  update_issuing_time: ->
    $('#invoice_issuing_time').val("#{$('#invoice_issuing_time_date').val()} #{$('#invoice_issuing_time_time').val()}:00")


window.addEventListener('turbolinks:load', () => new InvoicesForm())
